export default __webpack_public_path__ + "static/media/monster.242d6c05.png";